import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { authService } from "../services/backend";
import Loading from "./Loading";

const ProtectedRoute = ({ children, requiredRole }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const currentUser = await authService.getCurrentUser();
        setUser(currentUser);
      } catch (error) {
        console.error("Auth check failed:", error);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (loading) {
    return <Loading />;
  }

  // 1. Not Logged In -> Redirect to Login
  if (!user) {
    if (requiredRole === "admin") {
      return <Navigate to="/admin/login" replace />;
    } else {
      return <Navigate to="/reseller/login" replace />;
    }
  }

  // 2. Role Check (e.g., trying to access Admin but is Reseller)
  if (requiredRole && user.role !== requiredRole && user.role !== "admin") {
    // If admin, they can access everything. If not admin, strict check.
    // Actually, let's keep it simple:

    // If user is 'reseller' but wants 'admin' page -> Block
    if (requiredRole === "admin" && user.role !== "admin") {
      return <Navigate to="/reseller/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
